import React from "react";
import Container from "react-bootstrap/Container";
import { Heading, T } from "../components/helpful";
import BookViewer from "../components/pageFlip";
import { Button } from "primereact/button";

/* The class `LUpdateViewer` is a React component that displays a page titled "View Book" with a
subheading "Our last Update" and includes a `BookViewer` component. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class LUpdateViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "View Book",
      hotelImg: 0,
      desc: '',
    };
  }

  subHeading = () => {
    return <>{this.state.desc}</>;
  };
  render() {
    return (
      <div>
        <div className="lupdate-viewer">
          <div>
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>
          <div className="main-content">
            <BookViewer />
          </div>
        </div>
      </div>
    );
  }
}
